'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CollapsibleCard = require('./CollapsibleCard');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CollapsibleCard).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }